import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import mySvg from "../img/search.png";
import clear from "../img/clear.png";
import HomeSvg from "../img/home.svg";
import backArrow from "../img/back-arrow.png";

class Header extends Component {
  state = {
    serachValue: ""
  };
  onTextChanged = e => {
    console.log(
      `onTextChanged ==> name ${e.target.name} value name ${e.target.value}`
    );
    let value = e.target.value;
    this.setState({
      [e.target.name]: value
    });
    this.props.handleChange(value);
  };

  clearSearch = () => {
    this.setState({
      serachValue: ""
    });
    this.props.handleChange("");
  };
  render() {
    console.log("HeaderPoprs", this.props);

    const { serachValue } = this.state;
    const { pathname } = this.props.location;
    const isReportPage = pathname;
    console.log("isReportPage", isReportPage);
    const params = new URLSearchParams(window.location.search);
    const source = params.get("src");

    return (
      <div>
        {isReportPage === "/reports" ? null : (
          <div className="bg-color">
            <div className={source === "web" ? "app-header-web" : "app-header"}>
              {/* <div className="app-icon">
                                </div> */}
              <div className="heading-text">
                <img
                  className="back-icon"
                  src={backArrow}
                  onClick={() => window.history.back()}
                />
                <div>
                  <div
                    onClick={() => {
                      window.location = window.orignalURL;
                    }}
                  >
                    <strong>Hello!</strong> <br /> How can we help you?
                  </div>
                </div>
              </div>
              {/* <div className="app-quit">
                                </div> */}
            </div>
            <div className={source === "web" ? "app-header-web" : "app-header"}>
              {/* <div className="app-icon">
                                    {isReportPage === "/reports" ? <div className="faq-text">Reports</div> : null} 
                                </div> */}
              <div className="search-input search-container">
                {/* <img className='back-icon-mobileView' src={backArrow} onClick={() => window.history.back()} /> */}
                <div onClick={this.focus} className="bk-btn">
                  <img
                    className="back-arrow"
                    alt="back-btn-arrorw"
                    src={mySvg}
                  ></img>
                </div>

                <div className="search-c">
                  <input
                    type="text"
                    placeholder="e.g. eligibility, documents required, repayment"
                    name="serachValue"
                    className="search-input"
                    onChange={this.onTextChanged}
                    value={serachValue}
                  />
                </div>
                <div
                  onClick={this.clearSearch}
                  style={{ display: serachValue ? "" : "none" }}
                >
                  <img className="clear-icon" src={clear}></img>
                </div>
                {/* <img className="close-icon-mobileView" src={HomeSvg} onClick={() => { window.location = window.orignalURL }}></img> */}
              </div>
              {/* <div className="app-quit">
                                </div> */}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(Header);
